<template>
    <div class="definicao">
        <div class="conteudo">
            <label data-aos="fade-up" data-aos-duration="1000" class="titulo-geral">O que é o Planti?</label>
            <div data-aos="fade-up" data-aos-duration="800" class="linha"></div>
            <label data-aos="fade-up" data-aos-duration="800" class="subtitulo">Aplicativo criado no coração da Amazônia.</label>
            <img class="celular" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" src="../../assets/images/celular2.svg" alt="">
            <div class="part1">
                <label data-aos="fade-right" data-aos-duration="1000" class="titulo1">COMPARTILHE SUAS FOTOS</label>
                <img  data-aos="fade-right" data-aos-duration="1000" class="img-t11" src="../../assets/images/quadro-armacao.svg" alt="">
                <label data-aos="fade-right" data-aos-duration="1000" class="descricao1">Compartilhe as fotos de suas plantinhas preferidas e anuncie algumas delas para troca ou venda.</label>
            </div>
            <div class="part2">
                <label data-aos="fade-left" data-aos-duration="1000" class="titulo2">CHAT COM ANUNCIANTES</label>
                <img data-aos="fade-left" data-aos-duration="1000" class="img-t12" src="../../assets/images/bate-papo.svg" alt="">
                <label data-aos="fade-left" data-aos-duration="1000" class="descricao2">Você pode mandar mensagens para os anunciantes, tirar suas dúvidas e trocar idéias com outros amantes de plantas.</label>
            </div>
            <div class="part3">
                <label data-aos="fade-right" data-aos-duration="1000" class="titulo3">PERFIL SOCIAL</label>
                <img  data-aos="fade-right" data-aos-duration="1000" class="img-t13" src="../../assets/images/do-utilizador.svg" alt="">
                <label data-aos="fade-right" data-aos-duration="1000" class="descricao3">Crie e modele seu perfil social, faça novas amizades e mostre o tamanho do seu amor por plantinhas.</label>
            </div>
            <div class="part4">
                <label data-aos="fade-left" data-aos-duration="1000" class="titulo4">FEED DE ANÚNCIOS</label>
                <img data-aos="fade-left" data-aos-duration="1000" class="img-t14" src="../../assets/images/Vector.svg" alt="">
                <label data-aos="fade-left" data-aos-duration="1000" class="descricao4">Acompanhe as novidades de plantinhas em tempo real, fique por dentro do que as pessoas que você segue estão postando num clique.</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Definicao',
}
</script>

<style scoped lang="scss">
.definicao{
    position: relative;
}
.conteudo{
    position: relative;
    margin: 0 auto;
    display: flex;
    max-width: 1350px;
    height: 1248px;
    overflow: hidden;
}

.titulo-geral{
    position: absolute;
    width: 400px;
    left: 485px;
    top: 181px;
    font-style: normal;
    font-weight: normal;
    font-size: 46px;
    line-height: 50px;
    letter-spacing: 0.75px;
    color: #4F4F4F;
}
.linha{
  position: absolute;
  width: 195px;
  left: 585px;
  top: 250px;
  border: 1px solid #1D976C;
}
.subtitulo{
    position: absolute;
    width: 688px;
    height: 34px;
    left: 485px;
    top: 281px;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 34px;
    letter-spacing: 0.74px;
    color: #828282;
}
.celular{
    position: absolute;
    width: 425px;
    left: 470px;
    top: 353px;
}

//parte 1

.titulo1{
    position: absolute;
    width: 320px;
    left: 62px;
    top: 505px;
    font-style: normal;
    font-weight: normal;
    font-size: 23px;
    line-height: 38px;
    text-align: right;
    letter-spacing: 0.57px;
    color: #4F4F4F;
}
.img-t11{
    position: absolute;
    width: 38px;
    left: 402px;
    top: 505px;
}
.descricao1{
    position: absolute;
    width: 420px;
    left: 20px;
    top: 584px;
    font-style: normal;
    font-weight: 450;
    font-size: 17px;
    line-height: 32.5px;
    text-align: right;
    letter-spacing: 0.75px;
    color: #000000;
}

//Parte 2
.titulo2{
    position: absolute;
    width: 305px;
    left: 994px;
    top: 505px;
    font-style: normal;
    font-weight: normal;
    font-size: 23px;
    line-height: 38px;
    text-align: left;
    letter-spacing: 0.57px;
    color: #4F4F4F;
}
.img-t12{
    position: absolute;
    width: 38px;
    left: 930px;
    top: 505px;
}
.descricao2{
    position: absolute;
    width: 400px;
    left: 926px;
    top: 582px;
    font-style: normal;
    font-weight: 450;
    font-size: 17px;
    line-height: 32.5px;
    text-align: left;
    letter-spacing: 0.75px;
    color: #000000;
}

//parte 3
.titulo3{
    position: absolute;
    width: 320px;
    left: 62px;
    top: 778px;
    font-style: normal;
    font-weight: normal;
    font-size: 23px;
    line-height: 38px;
    text-align: right;
    letter-spacing: 0.57px;
    color: #4F4F4F;
}
.img-t13{
    position: absolute;
    width: 38px;
    left: 402px;
    top: 778px;
}
.descricao3{
    position: absolute;
    width: 420px;
    left: 20px;
    top: 845px;
    font-style: normal;
    font-weight: 450;
    font-size: 17px;
    line-height: 32.5px;
    text-align: right;
    letter-spacing: 0.75px;
    color: #000000;
}

//parte 4

.titulo4{
    position: absolute;
    width: 305px;
    left: 994px;
    top: 778px;
    font-style: normal;
    font-weight: normal;
    font-size: 23px;
    line-height: 38px;
    text-align: left;
    letter-spacing: 0.57px;
    color: #4F4F4F;
}
.img-t14{
    position: absolute;
    width: 30px;
    left: 930px;
    top: 778px;
}
.descricao4{
    position: absolute;
    width: 400px;
    left: 926px;
    top: 845px;
    font-style: normal;
    font-weight: 450;
    font-size: 17px;
    line-height: 32.5px;
    text-align: left;
    letter-spacing: 0.75px;
    color: #000000;
}

@media screen and (max-width: 1365px) {
    .conteudo{
        height: 91.45vw;
    }

    .titulo-geral{
        width: 29.2vw;
        left: 35.5vw;
        top: 13.3vw;
        font-size: 3.37vw;
    }

    .linha{
        width: 14.3vw;
        left: 42.85vw;
        top: 18.37vw;
    }

    .subtitulo{
        width: 30vw;
        left: 35.5vw;
        top: 20.6vw;
        font-size: 1.245vw;
    }

    .celular{
        width: 31.1vw;
        left: 34.4vw;
        top: 25.87vw;
    }

    .titulo1, .titulo2, .titulo3, .titulo4{
        width: 23.4vw;
        font-size: 1.685vw;
    }
    .titulo1, .titulo2{
        top: 37vw;
    }
    .titulo3, .titulo4{
        top: 57vw;
    }
    .titulo1, .titulo3{
        left: 4.54vw;
    }
    .titulo2, .titulo4{
        left: 72.80vw;
    }

    .img-t11, .img-t12, .img-t13{
        width: 2.8vw;
    }
    .img-t11, .img-t12{
        top: 37vw;
    }
    .img-t13, .img-t14{
        top: 57vw;
    }
    .img-t11, .img-t13{
        left: 29.455vw;
    }
    .img-t12, .img-t14{
        left: 68.1vw;
    }

    .descricao1, .descricao2,.descricao3, .descricao4{
        font-size: 1.249vw;
        line-height: 2.41vw;
    }

    .descricao1, .descricao3{
        width: 30.79vw;
        left: 1.50vw;
    }
    .descricao2,.descricao4{
         width: 29.34vw;
         left: 67.86vw;
     }
    .descricao1, .descricao2{
        top: 42.87vw;
    }
    .descricao3, .descricao4{
        top: 61.9vw;
    }
}

@media screen and (max-width: 1116px) {
    .conteudo{
        height: 920px;
        max-width: 686px;
    }
    .celular{
        display: none;
    }
    .titulo-geral{
        width: 100%;
        left: 180px;
        top: 140px;
        font-size: 38px;
    }

    .linha{
        width: 160px;
        left: 270px;
        top: 205px;
    }

    .subtitulo{
        width: 335px;
        left: 182px;
        top: 230px;
        font-size: 14px;
    }

    .titulo1, .titulo2, .titulo3, .titulo4{
        width: 262px;
        font-size: 19px;
    }
    .titulo1, .titulo3{
        left: 350px;
    }
    .titulo2, .titulo4{
        left: 80px;
    }
    .titulo1{
        top: 312px;
    }
    .titulo2{
        top: 450px;
    }
    .titulo3{
        top: 580px;
    }
    .titulo4{
        top: 715px;
    }


    .img-t11, .img-t12, .img-t13{
        width: 31.2344px;
    }
    .img-t11{
        top: 312px;
    }
    .img-t12{
        top: 450px;
    }
    .img-t13{
        top: 580px;
    }
    .img-t14{
        width: 27px;
        top: 715px;
    }
    .img-t11, .img-t13{
        left: 630px;
    }
    .img-t12, .img-t14{
        left: 30px;
    }

    .descricao1, .descricao2,.descricao3, .descricao4{
        font-size: 13.9388px;
        line-height: 26.8956px;
    }

    .descricao1, .descricao3{
        width: 344px;
        left: 316px;
    }
    .descricao2,.descricao4{
        width: 327.422px;
        left: 30px;
    }
    .descricao1{
        top: 352px;
    }
    .descricao2{
        top: 490px;
    }
    .descricao3{
        top: 620px;
    }
    .descricao4{
        top: 755px;
    }
}

@media screen and (max-width: 767px) {
    .conteudo{
        height: 700px;
        max-width: 400px;
        overflow: hidden;
        //background-color: #697aa455;
    }
    .celular{
        display: none;
    }
    .titulo-geral{
        top: 30px;
        left: 0;
        font-size: 24px;
        line-height: 32px;
        text-align: center;
        letter-spacing: 1px;
    }

    .linha{
        width: 140px;
        left: 130px;
        top: 70px;
    }

    .subtitulo{
        width: 100%;
        left: 0;
        top: 90px;
        text-align: center;
        font-size: 13px;
        line-height: 24px;
    }

    .titulo1, .titulo2, .titulo3, .titulo4{
        width: 262px;
        font-weight: 600;
        font-size: 17px;
        line-height: 32px;
    }
    .titulo1, .titulo3{
        left: 60px;
    }
    .titulo2, .titulo4{
        left: 60px;
    }
    .titulo1{
        top: 140px;
    }
    .titulo2{
        top: 270px;
    }
    .titulo3{
        top: 400px;
    }
    .titulo4{
        top: 525px;
    }


    .img-t11, .img-t12, .img-t13{
        width: 25px;
    }
    .img-t11, .img-t13{
        left: 330px;
    }
    .img-t12, .img-t14{
        left: 20px;
    }
    .img-t11{
        top: 140px;
    }
    .img-t12{
        top: 270px;
    }
    .img-t13{
        top: 400px;
    }
    .img-t14{
        width: 27px;
        top: 525px;
    }


    .descricao1, .descricao2,.descricao3, .descricao4{
        font-size: 13px;
        line-height: 24px;
    }

    .descricao1, .descricao3{
        width: 344px;
        left: 12px;
    }
    .descricao2,.descricao4{
        width: 327.422px;
        left: 20px;
    }
    .descricao1{
        top: 180px;
    }
    .descricao2{
        top: 310px;
    }
    .descricao3{
        top: 440px;
    }
    .descricao4{
        top: 570px;
    }
}


//@media screen and (max-width: 398px) {
//    .celular{
//        display: none;
//    }
//    .conteudo{
//        max-width: 360px;
//        overflow: hidden;
//        height: 530px;
//    }
//    .titulo-geral{
//        width: 232px;
//        left: 76px;
//        font-style: normal;
//        font-weight: bold;
//        font-size: 24px;
//        line-height: 32px;
//        display: flex;
//        align-items: center;
//        text-align: center;
//        letter-spacing: 1px;
//    }
//
//    .linha{
//        width: 160px;
//        left: 108px;
//    }
//
//    .subtitulo{
//        font-size: 16px;
//        line-height: 32px;
//        width: 313px;
//        height: 96px;
//        left: 25px;
//        display: flex;
//        align-items: center;
//        text-align: center;
//        letter-spacing: 0.75px;
//    }
//
//    .titulo1, .titulo2, .titulo3{
//        width: 238px;
//        height: 32px;
//        left: 65px;
//        font-style: normal;
//        font-weight: 600;
//        font-size: 18px;
//        line-height: 32px;
//        text-align: right;
//        letter-spacing: 0.75px;
//    }
//
//    .img-t11, .img-t12, .img-t13 {
//        width: 24px;
//        height: 24px;
//        left: 313px;
//    }
//
//    .descricao1, .descricao2, .descricao3{
//        width: 322px;
//        left: 17px;
//        top: 2102px;
//        font-style: normal;
//        font-weight: normal;
//        font-size: 14px;
//        line-height: 22px;
//        display: flex;
//        align-items: center;
//        text-align: right;
//        letter-spacing: 0.75px;
//    }
//    .titulo1{
//        top: 182px;
//    }
//    .titulo2{
//        top: 272px;
//    }
//    .titulo3{
//        top: 384px;
//    }
//
//    .img-t11{
//        top: 187px;
//    }
//
//    .img-t12{
//        top: 277px;
//    }
//
//    .img-t13{
//        top: 388px;
//    }
//
//    .descricao1{
//        top: 208px;
//    }
//    .descricao2{
//        top: 312px;
//    }
//    .descricao3{
//        top: 422px;
//    }
//}

//@media screen and (max-width: 1365px) {
//    .titulo-geral{
//        position: absolute;
//        width: 400px;
//        left: 485px;
//        top: 181px;
//        font-style: normal;
//        font-weight: normal;
//        font-size: 46px;
//        line-height: 50px;
//        letter-spacing: 0.75px;
//        color: #4F4F4F;
//    }
//
//    .linha{
//        position: absolute;
//        width: 195px;
//        left: 585px;
//        top: 250px;
//        border: 1px solid #1D976C;
//    }
//
//    .subtitulo{
//        position: absolute;
//        width: 688px;
//        height: 34px;
//        left: 485px;
//        top: 281px;
//        font-style: normal;
//        font-weight: normal;
//        font-size: 17px;
//        line-height: 34px;
//        letter-spacing: 0.74px;
//        color: #828282;
//    }
//    .celular{
//        width: 31.1vw;
//        //left: 65.5vw;
//    }
//}

</style>
